module.exports = __webpack_public_path__ + "static/media/schemes.752e31a6.svg";